// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Country  {
    _originalTypeClassName = "Loom.BO.Country";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Country.translate = translateService;
}
this.BorderCountries = [];
this.Currencies = [];
this.Holidays = [];
this.Cities = [];
this.Id = null;
this.Name = null;
this.ISOCode2 = null;
this.ISOCode2Alt = null;
this.ISOCode3 = null;
this.WorkingHoursOfDay = null;
this.OfficialName = null;
this.NativeName = null;
this.NumericCode = null;
this.Region = null;
this.SubRegion = null;
this.CallingCodes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
ISOCode2:any;
ISOCode2Alt:any;
ISOCode3:any;
WorkingHoursOfDay:any;
OfficialName:any;
NativeName:any;
NumericCode:any;
Region:any;
SubRegion:any;
CallingCodes:any;
BorderCountries:any;
Currencies:any;
Holidays:any;
Cities:any;
static setBorderCountries = ($this, items) => {
                if (items == null) items = [];
                if ($this.BorderCountries == null) $this.BorderCountries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BorderCountries.length > 0) {
                    Domain.Country.removeBorderCountries($this, $this.BorderCountries[0]);
                }

                Domain.Country.addManyBorderCountries($this, copyItems);
            }
static addManyBorderCountries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Country.addBorderCountries($this, items[i]);
                }
            }
static addBorderCountries = ($this, item) => {
                if ($this.BorderCountries == null) $this.BorderCountries = [];
                if (item == null || $this.BorderCountries.indexOf(item) > -1) return;
                $this.BorderCountries.push(item);
}
static addRangeBorderCountries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Country.addBorderCountries($this, item));
            }
static removeBorderCountries = ($this, item) => {
                if ($this == null || $this.BorderCountries == null || $this.BorderCountries.indexOf(item) === -1) return;
                var _index = $this.BorderCountries.indexOf(item);
                $this.BorderCountries.splice(_index, 1);
}
static clearBorderCountries = ($this) => { $this.BorderCountries = null; }
static setCurrencies = ($this, items) => {
                if (items == null) items = [];
                if ($this.Currencies == null) $this.Currencies = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Currencies.length > 0) {
                    Domain.Country.removeCurrencies($this, $this.Currencies[0]);
                }

                Domain.Country.addManyCurrencies($this, copyItems);
            }
static addManyCurrencies = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Country.addCurrencies($this, items[i]);
                }
            }
static addCurrencies = ($this, item) => {
                if ($this.Currencies == null) $this.Currencies = [];
                if (item == null || $this.Currencies.indexOf(item) > -1) return;
                $this.Currencies.push(item);
}
static addRangeCurrencies = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Country.addCurrencies($this, item));
            }
static removeCurrencies = ($this, item) => {
                if ($this == null || $this.Currencies == null || $this.Currencies.indexOf(item) === -1) return;
                var _index = $this.Currencies.indexOf(item);
                $this.Currencies.splice(_index, 1);
}
static clearCurrencies = ($this) => { $this.Currencies = null; }
static setHolidays = ($this, items) => {
                if (items == null) items = [];
                if ($this.Holidays == null) $this.Holidays = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Holidays.length > 0) {
                    Domain.Country.removeHolidays($this, $this.Holidays[0]);
                }

                Domain.Country.addManyHolidays($this, copyItems);
            }
static addManyHolidays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Country.addHolidays($this, items[i]);
                }
            }
static addHolidays = ($this, item) => {
                if ($this.Holidays == null) $this.Holidays = [];
                if (item == null || $this.Holidays.indexOf(item) > -1) return;
                $this.Holidays.push(item);
if (item.Country != $this) {
Domain.CountryHoliday.setCountry(item, $this);
}
}
static addRangeHolidays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Country.addHolidays($this, item));
            }
static removeHolidays = ($this, item) => {
                if ($this == null || $this.Holidays == null || $this.Holidays.indexOf(item) === -1) return;
                var _index = $this.Holidays.indexOf(item);
                $this.Holidays.splice(_index, 1);
item.Country = null;
}
static clearHolidays = ($this) => { $this.Holidays = null; }
static setCities = ($this, items) => {
                if (items == null) items = [];
                if ($this.Cities == null) $this.Cities = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Cities.length > 0) {
                    Domain.Country.removeCities($this, $this.Cities[0]);
                }

                Domain.Country.addManyCities($this, copyItems);
            }
static addManyCities = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Country.addCities($this, items[i]);
                }
            }
static addCities = ($this, item) => {
                if ($this.Cities == null) $this.Cities = [];
                if (item == null || $this.Cities.indexOf(item) > -1) return;
                $this.Cities.push(item);
if (item.Country != $this) {
Domain.City.setCountry(item, $this);
}
}
static addRangeCities = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Country.addCities($this, item));
            }
static removeCities = ($this, item) => {
                if ($this == null || $this.Cities == null || $this.Cities.indexOf(item) === -1) return;
                var _index = $this.Cities.indexOf(item);
                $this.Cities.splice(_index, 1);
item.Country = null;
}
static clearCities = ($this) => { $this.Cities = null; }

static CalculateBusinessDays($this: any, start: any,end: any,ignoreErrors: any): any{if (((new Date(start).getTime()) > (new Date(end).getTime()))) {if ((ignoreErrors)) {return 0;}else {throw Error(CLMS.Framework.String.Format("Start date cannot be past the end date! [{0}, {1}]", CLMS.Framework.DateTime.ToString(start, "dd/MM/yyyy"), CLMS.Framework.DateTime.ToString(end, "dd/MM/yyyy")));}}
let current = new Date();
let businessDays = 0;
current = start;
let controlCounter = 0;
while (((new Date(current).getTime()) <= (new Date(end).getTime()))) {let isBusinessDay = Domain.Country.IsDateBusinessDay($this, current);if ((isBusinessDay)) {businessDays = Joove.Common.safeNumber(businessDays) + Joove.Common.safeNumber(1);}else {}current = (moment(current).add(1, "d")).toDate();controlCounter = Joove.Common.safeNumber(controlCounter) + Joove.Common.safeNumber(1);if ((CLMS.Framework.Number.GreaterThan(() => controlCounter, () => 5000))) {throw Error("insane number of iterations in CalculateBusinessDays! Stack overflow imminent!");}}
return businessDays;
}
static CalculateBusinessDaysInMonth($this: any, year: any,month: any,ignoreErrors: any): any{let start = moment([year, (month) - 1, 1]).toDate();
let end = (moment((moment(start).add(1, "M")).toDate()).add(-1, "d")).toDate();
return Domain.Country.CalculateBusinessDays($this, new Date(new Date(start)?.setHours(0, 0, 0, 0)), new Date(new Date(end)?.setHours(0, 0, 0, 0)), ignoreErrors);
}
static CalculateBusinessDaysInYear($this: any, year: any,ignoreErrors: any): any{let start = moment([year, (1) - 1, 1]).toDate();
let end = moment([year, (12) - 1, 31]).toDate();
return Domain.Country.CalculateBusinessDays($this, new Date(new Date(start)?.setHours(0, 0, 0, 0)), new Date(new Date(end)?.setHours(0, 0, 0, 0)), ignoreErrors);
}
static IsDateBusinessDay($this: any, date: any): any{if (date == null) {throw Error("Null provided as date!");}
let nonworkingDay = Domain.Country.IsDateNonWorkingDay($this, date);
if (nonworkingDay?.IsHoliday) {return false;}
return true;
}
static IsDateNonWorkingDay($this: any, date: any): any{let result = new Domain.HolidayResult();
if (date == null) {result.IsHoliday = true;return result;}
let publicHoliday = Domain.Country.IsHoliday($this, date);
if (publicHoliday?.IsHoliday) {return publicHoliday;}
if (CLMS.Framework.Number.NotEqual(() => moment(date).day(), () => 0) && CLMS.Framework.Number.NotEqual(() => moment(date).day(), () => 6)) {result.IsHoliday = false;result.HolidayName = "Weekend";return result;}
result.IsHoliday = true;
return result;
}
static IsHoliday(country: any,date: any): any{let result = new Domain.HolidayResult();
let year = moment(date).year();
if (CLMS.Framework.Number.Equal(() => year, () => 1753)) {throw Error("IsHoliday: Incorrect refDate: " + date);}
let holiday = country?.Holidays?.linq?.where((a) => a?.Date != null && (new Date(new Date(new Date(a?.Date)?.setHours(0, 0, 0, 0))).getTime()) == (new Date(new Date(new Date(date)?.setHours(0, 0, 0, 0))).getTime()))?.firstOrDefault(null);
if (holiday != null && !(holiday?.IsWorkingDay)) {result.IsHoliday = true;result.HolidayName = holiday?.Name;}else {result.IsHoliday = false;}
return result;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}